<script>
import BaseNotificationComponent from '@/components/notifications/BaseNotificationComponent.vue'

export default {
  name: 'base-subscription-component',
  extends: BaseNotificationComponent
}
</script>
